


// import React, { useState } from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     Button,
//     Box,
//     Typography,
//     Grid,
// } from '@mui/material';
// import { Close as CloseIcon } from '@mui/icons-material';

// import '../../ContentManagement/Home/Modal/BannerinputGetModal.css'// Import external CSS
// import { MdCancel } from "react-icons/md";

// // import registration_complete_gif from "../../../Assets/registration_successful_gif.gif"
// import SchemeCard from '../../../Components/SchemeCard/SchemeCard';
// import cardImage from "../../../Assets/home_page_Image.png"

// const SelectSchemByOperatorModal = ({ open, onClose, setSubmittedValues, submittedValues, modalHeadingName }) => {
//     // const [uploadedFile, setUploadedFile] = useState(null);
//     const schemes = [
//         {
//             name: "Scheme Name 1",
//             valueOfPurchase: "$1000",
//             purchase: "13.8 Grm",
//             maturity: "24 Month's",
//             lockIn: "24 Month's",
//             benefit: "6%*",
//             closingDate: "15/Mar/2025",
//             backgroundImage: cardImage, // replace with the background image URL
//         },
//         {
//             name: "Scheme Name 2",
//             valueOfPurchase: "$10000",
//             purchase: "138 Grm",
//             maturity: "24 Month's",
//             lockIn: "24 Month's",
//             benefit: "6%*",
//             closingDate: "15/Mar/2025",
//             backgroundImage: cardImage, // replace with the background image URL
//         },

//     ];


//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 // maxWidth: "700px",
//                 // margin: "auto",
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px", // Target the Paper component
//                 },
//             }}
//         >
//             <Box sx={{ position: 'relative' }}>
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">

//                         <Box>
//                             <Typography className="custom-title-text" color='white'>
//                                 {/* {modalHeadingName} */}
//                                 Select Scheme
//                             </Typography>
//                         </Box>
//                     </DialogTitle>
//                 </Box>


//                 <DialogContent
//                     dividers

//                     style={{
//                         "& .MuiDialogContent-root": {
//                             padding: "none !important", // Ensures padding is removed, overriding other styles
//                         },
//                     }}
//                 >

//                     {/* <Grid container textAlign="center" p={2}> */}

//                     <Grid item xs={12} md={12}>
//                         <SchemeCard schemes={schemes} />


//                     </Grid>
//                     {/* </Grid> */}

//                 </DialogContent>


//             </Box >

//         </Dialog >
//     );
// };

// export default SelectSchemByOperatorModal;


import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Box,
    Typography,
    Grid,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import '../../ContentManagement/Home/Modal/BannerinputGetModal.css' // Import external CSS
import { MdCancel } from "react-icons/md";

// import registration_complete_gif from "../../../Assets/registration_successful_gif.gif"
import SchemeCard from '../../../Components/SchemeCard/SchemeCard';
import cardImage from "../../../Assets/home_page_Image.png";
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../ReduxStore/actions';

const SelectSchemByOperatorModal = ({ open, onClose, setSubmittedValues, submittedValues, modalHeadingName, handleNextModal }) => {
    // const [uploadedFile, setUploadedFile] = useState(null);


    const dispatch = useDispatch();

    const { getAllActivePlans } = useSelector((state) => state?.getAllActivePlans);
    const isVisible = useSelector((state) => state.button.isVisible);

    useEffect(() => {


        if (!open) return; // Only fetch when modal is open

        const fetchData = async () => {
            try {
                const data1 = { data: {}, method: "get", apiName: "getAllActivePlans" };
                await dispatch(actions.GETALLACTIVEPLANS(data1));

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchData();
    }, [dispatch, open]);


    console.log(getAllActivePlans?.data, "PurchaseSchemesPurchaseSchemes");

    const schemes = [
        {
            name: "Scheme Name 1",
            valueOfPurchase: "$1000",
            purchase: "13.8 Grm",
            maturity: "24 Month's",
            lockIn: "24 Month's",
            benefit: "6%*",
            closingDate: "15/Mar/2025",
            backgroundImage: cardImage, // replace with the background image URL
        },
        {
            name: "Scheme Name 2",
            valueOfPurchase: "$10000",
            purchase: "138 Grm",
            maturity: "24 Month's",
            lockIn: "24 Month's",
            benefit: "6%*",
            closingDate: "15/Mar/2025",
            backgroundImage: cardImage, // replace with the background image URL
        },
    ];

    return (
        <Dialog
            open={open}
            // onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "14px", // Target the Paper component
                },
            }}
        >
            <Box sx={{ position: 'relative' }}>
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={isVisible ? handleNextModal : onClose}
                        sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Box>
                            <Typography className="custom-title-text" color='white'>
                                {/* {modalHeadingName} */}
                                Select Scheme
                            </Typography>
                        </Box>
                    </DialogTitle>
                </Box>

                <DialogContent
                    dividers
                    sx={{
                        padding: 0, // Removes the padding completely
                        '& .MuiDialogContent-root': {
                            padding: 0, // Ensures no padding inside DialogContent
                        },
                    }}
                >
                    <Grid item xs={12} md={12}>
                        <SchemeCard schemes={schemes} handleNextModal={handleNextModal} />
                    </Grid>
                </DialogContent>
            </Box>
        </Dialog>
    );
};

export default SelectSchemByOperatorModal;
